import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_regenerate_api_key_btn = _resolveComponent("regenerate-api-key-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    label: "API Key",
    "model-value": _ctx.apiKey,
    outlined: "",
    readonly: ""
  }, {
    append: _withCtx(() => [
      _createVNode(_component_regenerate_api_key_btn, {
        "service-account-id": _ctx.serviceAccount.id,
        onRegenerated: _ctx.onRegenerated
      }, null, 8, ["service-account-id", "onRegenerated"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}